import { useRachelChatContext } from '../contexts/Rachel.context';
import { RachelAskUserPart, isAskUserPart } from '../rachelAskUser.utils';

type PendingAskUserPart = Extract<RachelAskUserPart, { state: 'input-available' }>;

export interface PendingAskUser {
  toolCallId: string;
  question: string;
  options: string[];
}

export const usePendingAskUser = (): PendingAskUser | null => {
  const { messages } = useRachelChatContext();
  const lastMessage = messages.at(-1);

  if (lastMessage?.role !== 'assistant') {
    return null;
  }

  const pendingPart = lastMessage.parts.find(
    (part): part is PendingAskUserPart => isAskUserPart(part) && part.state === 'input-available',
  );

  if (!pendingPart) {
    return null;
  }

  return {
    toolCallId: pendingPart.toolCallId,
    question: pendingPart.input.pergunta,
    options: pendingPart.input.opcoes,
  };
};
